import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = [<>
    <strong data-id="element-24">Pan artesanal con miga real</strong> que dura tierno por días y
    puede ir al trabajo sin desmoronarse
  </>, <>
    <strong data-id="element-25">Pasteles y budines perfectos</strong> que salen bien todas las
    veces, sin ese sabor a laboratorio que tienen los del super{' '}
  </>, <>
    <strong data-id="element-26">Postres riquísimos</strong> que puedes llevar a cualquier reunión y
    nadie notará que no tienen gluten... ni tú
  </>];
export function BenefitsSection() {
  return <section className="py-5 md:py-10 px-4 bg-brand-cream" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-green text-white text-center py-5 px-6 rounded-xl mb-8 shadow-lg" data-id="element-29">
          <h2 className="text-lg md:text-3xl font-heading font-bold uppercase tracking-wide" data-id="element-30">
            QUE VAS A LOGRAR...
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-31">
          {benefits.map((content, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-white p-6 md:p-8 rounded-xl shadow-sm border-l-[6px] border-brand-green text-center" data-id="element-32">
              <CheckCircle2 className="w-8 h-8 text-brand-green mx-auto mb-4" data-id="element-33" />
              <p className="text-lg text-brand-brownLight leading-relaxed [&_strong]:text-brand-brown" data-id="element-34">
                {content}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}